import {
  showToast,
  showErrorToast,
  showInquiryToast
} from '@/components/SnackBar/BaseSnackBar'
import {
  V1JobPostingActionType,
  type JobPostingServiceGetActionsResponseAction
} from 'mnvm-mypage-app-ts-if'

export const showMessageActions = (
  actionType: V1JobPostingActionType,
  listAction: JobPostingServiceGetActionsResponseAction[]
): void => {
  switch (actionType) {
    case V1JobPostingActionType.Inquiry:
    case V1JobPostingActionType.InquiryClosedJobPosting:
      showInquiryToast(
        'お問い合わせいただきありがとうございます。\n 近日中に詳細をお知らせいたしますので、弊社アドバイザーからのご連絡をお待ちください。'
      )
      break
    case V1JobPostingActionType.Apply:
      showToast('応募しました')
      break
    case V1JobPostingActionType.Decline:
      showToast('辞退しました')
      break
    case V1JobPostingActionType.Consider:
      showToast('検討中にしました')
      break
    case V1JobPostingActionType.UnderConsider:
      showToast('検討中を解除しました')
      break
    default:
      showToast('完了しました')
      break
  }
}

export const showErrorMessageActions = (
  actionType: V1JobPostingActionType,
  listAction: JobPostingServiceGetActionsResponseAction[]
): void => {
  switch (actionType) {
    case V1JobPostingActionType.Inquiry:
    case V1JobPostingActionType.InquiryClosedJobPosting:
      showErrorToast('問い合わせすることが出来ませんでした')
      break
    case V1JobPostingActionType.Apply:
      showErrorToast('求人へ応募することが出来ませんでした。')
      break
    case V1JobPostingActionType.Decline:
      showErrorToast('辞退することが出来ませんでした。')
      break

    default:
      showErrorToast('エラーが発生しました。時間を空けて再度お試しください。')
      break
  }
}

export const downloadFile = (downloadUrl: string): void => {
  let filename = ''
  fetch(downloadUrl, {
    credentials: 'include',
    headers: {
      'X-Client-Type': 'web'
    }
  })
    .then(async (response) => {
      const headerFilename = response.headers.get('Content-Disposition')
      if (headerFilename === null) throw new Error('headerFilename null')
      const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
        headerFilename
      )
      const filenameEncoded =
        match?.[1] != null ? match[1].replace(/['"]/g, '') : 'downloaded'
      filename = decodeURIComponent(filenameEncoded)
      return await response.blob()
    })
    .then((blob) => {
      const blobURL = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobURL
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      onShowToastDownloadFile(true)
    })
    .catch((err) => {
      console.log('common downloadFile error: ', err)
      onShowToastDownloadFile(false)
    })
}

export const downloadFileFromBase64 = (
  base64Data: string,
  filename: string
): void => {
  const byteArray = convertBase64ToByteArr(base64Data)
  const mimeType = detectMimeType(base64Data)
  const blobURL = URL.createObjectURL(new Blob([byteArray], { type: mimeType }))
  const a = document.createElement('a')
  a.href = blobURL
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => {
    URL.revokeObjectURL(blobURL)
  }, 7000)
}

const convertBase64ToByteArr = (base64Data: string): Uint8Array => {
  const byteCharacters = atob(base64Data)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)
  return byteArray
}

const signatures: any = {
  JVBERi0: 'application/pdf',
  R0lGODdh: 'image/gif',
  R0lGODlh: 'image/gif',
  iVBORw0KGgo: 'image/png',
  '/9j/': 'image/jpg'
}

const detectMimeType = (b64: string): any => {
  for (const s in signatures) {
    if (b64.indexOf(s) === 0) {
      return signatures[s]
    }
  }
}

export const onShowToastDownloadFile = (success: boolean): void => {
  if (success) {
    showToast('ダウンロードが完了しました。')
  } else {
    showErrorToast('ダウンロードが失敗しました。')
  }
}
